import React from 'react';

import { Modal, message , Row, Col, Form, Input, Button, Select} from 'antd';



import {getTypeArticleOption} from "../util/Toolbox";

import './css/home.css';
import conseils from './conseils.json';

import {
  EditOutlined
} from '@ant-design/icons';

import BOUTON_ANALYSE             from './assets/home/BOUTON_ANALYSE.png';
import BOUTON_CALCUL_VOLUME       from './assets/home/BOUTON_CALCUL_VOLUME.png';
import BOUTON_HISTORIQUE_ANALYSE  from './assets/home/BOUTON_HISTORIQUE_ANALYSE.png';
import BOUTON_GOUTTE              from './assets/home/BOUTON_PRODUITS.png';
import spintouch_picto            from './assets/home/BOUTON_SPINTOUCH.png';
import logo_purissimeau           from './assets/home/logo-purissimeau-1-1-1.png';

import ElectronWaterLinkService   from '../services/ElectronWaterLinkService'


class Home extends React.Component {

  state = {
    conseil_LIST : [],
    // Détection de l'environnement Electron pour contrôler l'affichage Spintouch
    // et masquer les conseils en mode desktop. Test synchrone dès la construction
    // pour éviter un flash au premier rendu.
    isElectron: ElectronWaterLinkService.isElectronApp(),
    // Etat reel du photometre, pour la pastille de la tuile Configuration :
    // 'inconnu' (pas encore interroge), 'absent' (WaterLink Connect injoignable),
    // 'horsligne' (service present, aucun appareil branche), 'pret'.
    spintouchEtat : 'inconnu'
  }


  constructor(props) {
    super(props);
    // Les champs de classe (state) sont initialises juste apres super(),
    // this.state.isElectron est donc deja disponible ici.
    //
    // Le fond bleu plein ecran du mode desktop vient de .ant-layout, qui est un
    // ancetre de Home (rendu par AvaApp) : aucun selecteur descendant ne peut
    // l'atteindre, d'ou la classe posee sur body. Pose des le constructeur et
    // non dans componentDidMount pour eviter un flash blanc au premier paint.
    // classList.add est idempotent : sans risque en StrictMode.
    if (this.state.isElectron) {
      document.body.classList.add('homeDesktop');
    }
  }


  componentWillUnmount() {
    document.body.classList.remove('homeDesktop');
  }


  async componentDidMount() {

    // Repose necessaire : en StrictMode (dev), React monte, demonte puis
    // remonte sans rappeler le constructeur, ce qui laisserait le body sans
    // la classe apres le passage dans componentWillUnmount.
    if (this.state.isElectron) {
      document.body.classList.add('homeDesktop');
    }

    let conseil_LIST = [];

    let conseil = {

    }


    conseil_LIST.push(conseil);

    this.setState({conseil_LIST});

    // Uniquement en mode desktop : hors Electron la tuile n'est pas affichee,
    // inutile d'interroger le service WaterLink.
    if (this.state.isElectron) {
      this.chargerEtatSpintouch();
    }

  }


  // Distingue les deux maillons de la chaine : le service WaterLink Connect
  // d'une part, le photometre physique de l'autre. Le service repond meme
  // quand aucun appareil n'est branche, d'ou le test sur Status (5 = pret).
  chargerEtatSpintouch = async () => {

    try {
      await ElectronWaterLinkService.checkService();
      const status = await ElectronWaterLinkService.getStatus();
      this.setState({spintouchEtat : (status && status.Status === 5) ? 'pret' : 'horsligne'});
    } catch (error) {
      this.setState({spintouchEtat : 'absent'});
    }

  }


  // Pastille d'etat sur la tuile Configuration : le technicien voit si le
  // photometre est operationnel sans ouvrir la page. Rien tant que l'etat
  // n'a pas ete determine, pour ne pas afficher une couleur trompeuse.
  renderPastilleSpintouch = () => {

    const couleurs = {
      pret      : '#52c41a',
      horsligne : '#faad14',
      absent    : '#ff4d4f'
    };

    const infobulles = {
      pret      : 'Photomètre connecté et prêt',
      horsligne : 'WaterLink Connect détecté, aucun photomètre branché',
      absent    : 'WaterLink Connect introuvable sur ce poste'
    };

    const couleur = couleurs[this.state.spintouchEtat];

    if (!couleur) {
      return null;
    }

    return (
      <span
        title={infobulles[this.state.spintouchEtat]}
        style={{
          position        : 'absolute',
          top             : 4,
          right           : 4,
          width           : 22,
          height          : 22,
          borderRadius    : '50%',
          backgroundColor : couleur,
          border          : '3px solid #fff',
          boxShadow       : '0 1px 3px rgba(0,0,0,0.35)'
        }}
      />
    );

  }


  /*
  <Col style={{ cursor: 'pointer'}} className="" span={12} onClick= {this.validationAUTREFORME}>
    <div className= "homeMenuCell">
      <img  style ={{marginTop:25}} src={BOUTON_GOUTTE} />
    </div>
  </Col>
  */


  render() {

      return (

        <div>

          <div className = {this.state.isElectron ? 'wrapper_home wrapper_home--desktop' : 'wrapper_home'}>

          <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1"/>

          <div className = "wrapper_home_header">

          </div>


          <div className = "containersHome">

            <Row className={this.state.isElectron ? 'homeMenuRow homeMenuRow--desktop' : 'homeMenuRow'} style = {{marginTop:12}} gutter={[0, 0]}>

              <Col style={{ cursor: 'pointer'}} className="" span={12} onClick= {this.validationRECTANGULAIRE}>
                <div  className= "homeMenuCell">
                  <a href = "/forms"><img loading="lazy"  src={BOUTON_ANALYSE} width ="180px"  height ="180px" /></a>
                </div>
              </Col>

              <Col style={{ cursor: 'pointer'}} className="" span={12} onClick= {this.validationOVALE}>
                <div className= "homeMenuCell">
                  <a href = "/simulateur"><img  loading="lazy" src={BOUTON_CALCUL_VOLUME}  width ="180px"  height ="180px" /></a>
                </div>
              </Col>

              <Col style={{ cursor: 'pointer'}} className="" span={12} onClick= {this.validationRONDE}>
                <div className= "homeMenuCell">
                  <a href = "/historique"><img loading="lazy"  src={BOUTON_HISTORIQUE_ANALYSE}   width ="180px"  height ="180px" /></a>
                </div>
              </Col>

              <Col style={{ cursor: 'pointer'}} className="" span={12}>
                <div className= "homeMenuCell">
                  <a href = "/analyseProduitsAll"><img loading="lazy"  src={BOUTON_GOUTTE}  width ="180px"  height ="180px" /></a>
                </div>
              </Col>

              {this.state.isElectron == true &&
                <Col style={{ cursor: 'pointer'}} className="" span={12}>
                  <div className= "homeMenuCell">
                    <a href = "/spintouch" style={{position:'relative', display:'inline-block'}}>
                      <img loading="lazy" src={spintouch_picto} width="180px" height="180px" />
                      {this.renderPastilleSpintouch()}
                    </a>
                  </div>
                </Col>
              }

            </Row>

          {this.state.isElectron !== true &&
            <div>

              <div className = "home_titre">
                <p>Les conseils Purissim'eau</p>
              </div>

              <div className="scrolling-wrapper-flexbox">

              {
                conseils.map((item) => (
                  (
                      <div className="card">
                      <span>
                        <a style = {{color:'#0093CF'}} className = "colorCard" target="_blank" href={item.url}>
                          <img loading="lazy" src={require(`./assets/conseils/${item.nameImg}`)} alt=""/>
                          {item.libelle}
                        </a>
                      </span>
                      </div>
                  )

                  )
                )
              }
              </div>

            </div>
          }


          </div>

          {/* Logo de marque sous l'encart blanc, en mode desktop uniquement :
              sur le web et le mobile, cette zone est occupee par le carrousel
              des conseils. */}
          {this.state.isElectron &&
            <div className = "home_logo_marque">
              <div className = "home_logo_marque_fond">
                <img
                  loading="lazy"
                  src={logo_purissimeau}
                  alt="Purissim'eau — Les produits de la piscine et spa"
                />
              </div>
            </div>
          }

        </div>

        </div>

      )

    };
}


export default Home;
